var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "1000" },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _vm.show
        ? _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { short: "", dark: "", color: "primary" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: { click: _vm.cancel }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                  _c("v-toolbar-title", [
                    _vm._v(" " + _vm._s(_vm.$t("common.search")) + " ")
                  ])
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    {
                      staticClass: "mx-3 mt-2",
                      model: {
                        value: _vm.searchParamsValid,
                        callback: function($$v) {
                          _vm.searchParamsValid = $$v
                        },
                        expression: "searchParamsValid"
                      }
                    },
                    [
                      _c(
                        "v-row",
                        { staticClass: "mt-3", attrs: { align: "center" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "6" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.operators,
                                  label: "Company"
                                },
                                model: {
                                  value: _vm.editableSearchParams.companyId,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editableSearchParams,
                                      "companyId",
                                      $$v
                                    )
                                  },
                                  expression: "editableSearchParams.companyId"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "6" } },
                            [
                              _c("v-text-field", {
                                attrs: { label: "Fleet" },
                                model: {
                                  value: _vm.editableSearchParams.fleetId,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editableSearchParams,
                                      "fleetId",
                                      $$v
                                    )
                                  },
                                  expression: "editableSearchParams.fleetId"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { staticClass: "mt-3", attrs: { align: "center" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "4" } },
                            [
                              _c("v-text-field", {
                                attrs: { label: "Vehicle Id" },
                                model: {
                                  value: _vm.editableSearchParams.vehicleId,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editableSearchParams,
                                      "vehicleId",
                                      $$v
                                    )
                                  },
                                  expression: "editableSearchParams.vehicleId"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "4" } },
                            [
                              _c("v-text-field", {
                                attrs: { label: "Vehicle Number" },
                                model: {
                                  value: _vm.editableSearchParams.vehicleNumber,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editableSearchParams,
                                      "vehicleNumber",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "editableSearchParams.vehicleNumber"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "4" } },
                            [
                              _c("v-text-field", {
                                attrs: { label: "Registration Plate Number" },
                                model: {
                                  value:
                                    _vm.editableSearchParams
                                      .registrationPlateNumber,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editableSearchParams,
                                      "registrationPlateNumber",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "editableSearchParams.registrationPlateNumber"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { staticClass: "mt-3", attrs: { align: "center" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "4" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.vehicleStatuses,
                                  label: "Vehicle Status"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function(ref) {
                                        var item = ref.item
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.vehicleStatusToString(item)
                                              ) +
                                              " "
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "item",
                                      fn: function(ref) {
                                        var item = ref.item
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.vehicleStatusToString(item)
                                              ) +
                                              " "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  4167250908
                                ),
                                model: {
                                  value: _vm.editableSearchParams.vehicleStatus,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editableSearchParams,
                                      "vehicleStatus",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "editableSearchParams.vehicleStatus"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "4" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.vehicleTwinTypes,
                                  label: "Twin Type"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function(ref) {
                                        var item = ref.item
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.vehicleTwinTypeToString(
                                                  item
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "item",
                                      fn: function(ref) {
                                        var item = ref.item
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.vehicleTwinTypeToString(
                                                  item
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1680324828
                                ),
                                model: {
                                  value: _vm.editableSearchParams.twinType,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editableSearchParams,
                                      "twinType",
                                      $$v
                                    )
                                  },
                                  expression: "editableSearchParams.twinType"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "4" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.integrationSources,
                                  label: "Integration Source"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function(ref) {
                                        var item = ref.item
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.integrationSourceToString(
                                                  item
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "item",
                                      fn: function(ref) {
                                        var item = ref.item
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.integrationSourceToString(
                                                  item
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1691593788
                                ),
                                model: {
                                  value:
                                    _vm.editableSearchParams.integrationSource,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.editableSearchParams,
                                      "integrationSource",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "editableSearchParams.integrationSource"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    { attrs: { color: "primary" }, on: { click: _vm.search } },
                    [_vm._v(" " + _vm._s(_vm.$t("common.search")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    { staticClass: "ml-2", on: { click: _vm.cancel } },
                    [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
                  ),
                  _c("v-spacer")
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }